import { useMemo } from "react";
import { PageRoutes } from "../constants/routes";

interface RankInfo {
  rank?: number;
  type?: "allTime" | "weekly" | "monthly" | "daily";
  rankState?: "up" | "down";
}

const getNewRankWithState = (
  savedRankInfoList: RankInfo[],
  newRankInfo: RankInfo,
): RankInfo => {
  if (!newRankInfo.rank) return newRankInfo;
  const preRankInfo = savedRankInfoList?.find(
    (rank) => rank?.type === newRankInfo.type,
  );

  const newRankState =
    !preRankInfo?.rank || preRankInfo?.rank >= newRankInfo.rank ? "up" : "down";
  return { ...newRankInfo, rankState: newRankState };
};

const updateSavedRankInfo = (
  savedRankInfoList: RankInfo[],
  newRankInfo: RankInfo,
) => {
  const defaultInfo = [
    { type: "allTime" },
    { type: "weekly" },
    { type: "monthly" },
    { type: "daily" },
  ];
  const updatedRankInfo = defaultInfo.map((item) => {
    if (newRankInfo.type === item.type) return newRankInfo;
    else if (!savedRankInfoList || !Array.isArray(savedRankInfoList))
      return item;
    else return savedRankInfoList?.find((r) => r?.type === item.type);
  });
  localStorage.setItem("user-rank-info", JSON.stringify(updatedRankInfo));
};

export const useRankInfo = (newRankInfo: RankInfo) => {
  const newRankWithState = useMemo(() => {
    const savedRankInfoList = JSON.parse(
      localStorage.getItem("user-rank-info") || "[]",
    ) as RankInfo[];

    const newRankWithState = getNewRankWithState(
      savedRankInfoList,
      newRankInfo,
    );

    if (window.location.pathname.includes(PageRoutes.LeaderboardActivity)) {
      return null;
    }

    updateSavedRankInfo(savedRankInfoList, newRankWithState);
    return newRankWithState;
  }, [newRankInfo]);

  return { newRankWithState };
};
